
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { EditLevelSectionSidebar } from "./EditLevelSectionSidebar";
import CoreDetails from "./CoreDetails";
import EditContent from "./EditContent";
import EditFAQ from "./EditFAQ";
import EditQuiz from "./EditQuiz";
import EditTips from "./EditTips";
import EditScripts from "./EditScripts";
import EditPractice from "./EditPractice";
import EditPrompts from "./EditPrompts";
import { PageTitle, PageHeader } from "../../../../../components/StyledElements";
import { getLevelSectionInfo, getLevelSectionContent } from "../../../../../services/courses"
import { AppContext } from "../../../../../contexts/AppContext";
import swal from "sweetalert2";

import { useCourseContext } from "../../../../../contexts/CoursesContext";

export const EditLevelSection = ({ courseLevel }) => {
  console.log("!!! RENDERING EditLevelSection COMPONENT");
  const { selectedClient } = useContext(AppContext);
  const { updateContentStatuses } = useCourseContext();
  const navigate = useNavigate();
  const { level_section_id } = useParams();
  const [levelSection, setLevelSection] = useState();
  const [showSidebar, setShowSidebar] = useState(true);
  const [selectedTab, setSelectedTab] = useState(window.location.hash ? window.location.hash.substr(1) : "details");
  const { selectedCourse, updatedCourse } = useCourseContext();
  const [courseId, setCourseId] = useState();
  const [courseTitle, setCourseTitle] = useState();
  const [courseLevelId, setCourseLevelId] = useState();
  const [courseLevelTitle, setCourseLevelTitle] = useState();
  const [sectionContent, setSectionContent] = useState([]);


  useEffect(() => {
    if (level_section_id) {
      if (updatedCourse) {
        let section = null;
        let level = null;

        updatedCourse.levels.forEach((l) => {
          l.sections.forEach((s) => {
            if (s.public_id === level_section_id) {
              section = s;
              level = l;
            }
          })
        });

        setLevelSection(section);
        setCourseId(updatedCourse.public_id);
        setCourseTitle(updatedCourse.title);
        setCourseLevelId(level.public_id);
        setCourseLevelTitle(level.title);
      } else {
        const fetchLevelSection = async () => {
          const results = await getLevelSectionInfo(level_section_id, selectedClient);
          console.log("!!! level section RESULTS: ", results);
          if (results.success) {
            const section = results.level_section;
            setLevelSection(section);
            setCourseId(section.course_id);
            setCourseTitle(section.course_title);
            setCourseLevelId(section.level_id);
            setCourseLevelTitle(section.level_title);

            updateContentStatuses(section.course_id);
          } else {
            swal.fire({
              title: "Error",
              text: results.message || "Failed to fetch course level details.",
              icon: "error",
            }).then(() => {
              navigate(`/courses/${selectedCourse?.public_id}/levels`);
            });
          }
        };
        fetchLevelSection();

      }

      const fetchSectionContent = async () => {
        // Fetch content blocks for the section
        // This is a placeholder function. You would replace this with an actual API call.
        const results = await getLevelSectionContent(level_section_id, selectedClient);
        if (results.success) {
          console.log("!!! content blocks RESULTS: ", results);
          setSectionContent(results.section_content, selectedClient);
        } else {
          console.error("Failed to fetch content blocks for the section.");
        }
      }
      fetchSectionContent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [level_section_id, updatedCourse]);


  console.log("!!! course level ID: ", level_section_id);

  if (!levelSection) {
    return;
  }

  return (
    <div style={{ display: "flex", flexDirection: "row", backgroundColor: "var(--main-bg)", height: "100%" }}>
      <div style={{ display: "flex", flexDirection: "row", backgroundColor: "var(--main-bg)" }}>

        <EditLevelSectionSidebar
          show={showSidebar}
          levelSection={levelSection}
          defaultSelectedTab={selectedTab}
          onNavItemClicked={(navItem) => {
            setSelectedTab(navItem);
          }}
          onToggle={() => {
            setShowSidebar(!showSidebar);
          }}
        />
      </div>
      <div
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          width: `calc(100% - ${showSidebar ? "250px" : "0px"})`,
          minHeight: "calc(100vh - 40px)",
          position: "relative",
          backgroundColor: "var(--content-item-bg)",
          padding: "20px",
          borderRadius: "8px",
          color: "var(--main-font-color)",
          zIndex: 1,
          /*height: "2000px",*/
        }}
      >
        <PageHeader style={{ position: "sticky", top: "0px", backgroundColor: "var(--content-item-bg)", zIndex: 2, display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
          <div>
            <PageTitle title={`${courseId ? "Edit" : "New"} Level Section`} style={{ marginBottom: "10px" }} />
            {courseTitle ?
              <PageTitle onClick={() => { navigate(`/course/${courseId}`); }} title={<><i className="fa fa-arrow-left" style={{ marginRight: "10px" }} />{`Course: ${courseTitle}`}</>} style={{ marginBottom: "10px", fontWeight: "500", fontSize: "20px", cursor: "pointer" }} />
              : null}
            <PageTitle onClick={() => { navigate(`/courselevel/${courseLevelId}`); }} title={<><i className="fa fa-arrow-left" style={{ marginRight: "10px" }} />{`Level: ${courseLevelTitle}`}</>} style={{ marginBottom: "10px", fontWeight: "500", fontSize: "20px", cursor: "pointer" }} />
            <PageTitle onClick={() => { navigate(`/levelsection/${levelSection.public_id}`); }} title={<><i className="fa fa-arrow-left" style={{ marginRight: "10px" }} />{`Section: ${levelSection.title}`}</>} style={{ marginBottom: "10px", fontWeight: "500", fontSize: "20px", cursor: "pointer" }} />
          </div>
        </PageHeader>
        <div style={{ backgroundColor: "var(--content-item-bg)", marginTop: "20px", marginBottom: "40px", height: "calc(100% - 80px)" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px", height: "100%" }}>
            <div style={{ width: "100%", height: "100%" }}>
              <CoreDetails

                levelSection={sectionContent}
                style={{ display: selectedTab === "details" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <EditContent
                courseId={courseId}
                levelId={courseLevelId}
                levelSection={sectionContent}
                style={{ display: selectedTab.match(/^content/) ? "flex" : "none" }}
                onUpdateContent={(updatedBlock, deleted = false) => {
                  // Update the sectionContent state with the updated block
                  console.log("!!! IN EDIT UPDATED BLOCK: ", updatedBlock);
                  const updatedSectionContent = { ...sectionContent };

                  if (deleted) {
                    updatedSectionContent.content_blocks = updatedSectionContent.content_blocks.filter((block) => block.public_id !== updatedBlock.public_id);
                    setSectionContent(updatedSectionContent);
                    return;
                  }

                  updatedSectionContent.content_blocks = updatedSectionContent.content_blocks.map((block) => {
                    if (block.public_id === updatedBlock.public_id) {
                      return updatedBlock;
                    }
                    return block;
                  });
                  setSectionContent(updatedSectionContent);
                }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <EditQuiz
                levelSection={sectionContent}
                style={{ display: selectedTab.match(/^quiz/) ? "flex" : "none" }}
                onUpdateQuestion={(updatedQuestion, deleted = false) => {
                  // Update the sectionContent state with the updated question
                  console.log("!!! IN EDIT UPDATED QUESTION: ", updatedQuestion);
                  const updatedSectionContent = { ...sectionContent };

                  if (deleted) {
                    updatedSectionContent.quiz.questions = updatedSectionContent.quiz.questions.filter((question) => question.public_id !== updatedQuestion.public_id);
                    setSectionContent(updatedSectionContent);
                    return;
                  }

                  // Find the question in the quiz questions array and update it
                  updatedSectionContent.quiz.questions = updatedSectionContent.quiz.questions.map((question) => {
                    if (question.public_id === updatedQuestion.public_id) {
                      return updatedQuestion;
                    }
                    return question;
                  });
                  setSectionContent(updatedSectionContent);
                }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <EditFAQ
                levelSection={sectionContent}
                style={{ display: selectedTab.match(/^faq/) ? "flex" : "none" }}
                onUpdateFAQ={(updatedFAQ) => {
                  const { group, question } = updatedFAQ;
                  console.log("!!! IN EDIT UPDATED FAQ: ", updatedFAQ);
                  const updatedSectionContent = { ...sectionContent };
                  updatedSectionContent.faq_groups = updatedSectionContent.faq_groups.map((g) => {
                    if (g.public_id === group.public_id) {
                      g.title = group.title;
                      g.questions = g.questions.map((q) => {
                        if (q.public_id === question.public_id) {
                          return question;
                        }
                        return q;
                      });

                      return g;
                    }
                    return g;
                  });
                  setSectionContent(updatedSectionContent);
                }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <EditScripts
                levelSection={sectionContent}
                style={{ display: selectedTab === "scripts" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <EditTips
                levelSection={sectionContent}
                style={{ display: selectedTab === "tips" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <EditPractice
                levelSection={sectionContent}
                style={{ display: selectedTab === "practice" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <EditPrompts
                levelSection={sectionContent}
                style={{ display: selectedTab === "prompts" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditLevelSection;

